import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "t2-block2" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "InforDisclosure" }
const _hoisted_4 = { class: "tab_ul clearfix" }
const _hoisted_5 = { class: "zong_tagContent" }
const _hoisted_6 = { class: "tagContent" }
const _hoisted_7 = { class: "InforDisclosure_con" }
const _hoisted_8 = { class: "list_com" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "time" }
const _hoisted_11 = { class: "tagContent" }
const _hoisted_12 = { class: "tagContent" }
const _hoisted_13 = { class: "InforDisclosure_con" }
const _hoisted_14 = { class: "list_com" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "time" }
const _hoisted_17 = { class: "tagContent" }
const _hoisted_18 = { class: "tagContent" }

import { ref } from "vue";
import { useStore } from "vuex";
import { getNewsContentList } from "@/config/request";
import { useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore();
const router = useRouter();

let selectTagNum = ref("0");
const selectTag = (num: string) => {
  selectTagNum.value = num;
};
const publicity = () => {
  router.push("/publicity");
};
const creditPublicity = () => {
  router.push("/publicityIndex");
};
const VRList = () => {
  router.push("/VRList");
};
const TZList = () => {
  router.push("/tz");
};
let newsTypeId = ref(""); //  新闻类型id
let newsList1 = ref([]) as any; //  新闻列表1
let newsList2 = ref([]) as any; //  新闻列表2
let newsList3 = ref([]) as any; //  新闻列表3

const init = async () => {
  const newsTypeList = (await store.dispatch("getNewsType")) as any;
  newsTypeList.forEach((res: any) => {
    if (res.themeName === "自贸区信息公开") {
      newsTypeId.value = res.id;
      return false;
    }
  });
  newsList1.value = await getNewsList("通知公告");
  newsList2.value = await getNewsList("政策法规");
  newsList3.value = await getNewsList("政策解读");
};
const getNewsList = async (typeName: string) => {
  let newsList = [];
  const param = {
    themeId: newsTypeId.value,
    typeName: typeName,
  };
  const res = (await getNewsContentList(param)) as any;
  if (res.result?.records.length > 6) {
    newsList = res.result?.records.slice(0, 6);
  } else {
    newsList = res.result?.records;
  }
  return newsList;
};
const showDetail = (item: any) => {
  router.push({
    path: "/news-detail",
    query: {
      id: item.id,
    },
  });
};
const toNewsList = () => {
  let typeName = "";
  if (selectTagNum.value === "0") {
    typeName = "通知公告";
  } else if (selectTagNum.value === "1") {
    typeName = "政策法规";
  } else if (selectTagNum.value === "2") {
    typeName = "政策解读";
  }
  let param = {
    themeId: newsTypeId.value,
    typeName: typeName,
  };
  router.push({
    path: "/news-list",
    query: param,
  });
};
const openLink = (url: string) => {
  let path = `/iframe?url=${url}`;
  const res = router.resolve(path);
  window.open(res.href);
};
init();

return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[19] || (_cache[19] = _createElementVNode("img", {
      src: "images/fangwu.png",
      class: "fangwu"
    }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", { class: "t2_title" }, [
          _createElementVNode("a", { onClick: toNewsList }, [...(_cache[3] || (_cache[3] = [
            _createTextVNode("查看更多", -1),
            _createElementVNode("i", { class: "leftAndright" }, null, -1)
          ]))]),
          _cache[4] || (_cache[4] = _createElementVNode("span", null, [
            _createTextVNode("自贸区信息公开"),
            _createElementVNode("br"),
            _createElementVNode("small", null, "FREE TRADE ZONE Information disclosure")
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("ul", _hoisted_4, [
              _createElementVNode("li", {
                class: _normalizeClass({ selectTag: _unref(selectTagNum) === '0' })
              }, [
                _createElementVNode("a", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (selectTag('0')))
                }, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("img", { src: "images/tabicon1.png" }, null, -1),
                  _createElementVNode("span", null, "通知公告", -1)
                ]))])
              ], 2),
              _cache[8] || (_cache[8] = _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "http://www.kfsfq.gov.cn/cxythsfq/c00092/pc/list.html",
                  target: "_blank"
                }, [
                  _createElementVNode("img", { src: "images/tabicon2.png" }),
                  _createElementVNode("span", null, "政策法规")
                ])
              ], -1)),
              _cache[9] || (_cache[9] = _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "http://www.kfsfq.gov.cn/cxythsfq/c01011/pc/list.html",
                  target: "_blank"
                }, [
                  _createElementVNode("img", { src: "images/tabicon3.png" }),
                  _createElementVNode("span", null, "政策解读")
                ])
              ], -1)),
              _createElementVNode("li", {
                class: _normalizeClass({ selectTag: _unref(selectTagNum) === '3' })
              }, [
                _createElementVNode("a", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (selectTag('3')))
                }, [...(_cache[6] || (_cache[6] = [
                  _createElementVNode("img", { src: "images/tabicon4.png" }, null, -1),
                  _createElementVNode("span", null, "综合查询", -1)
                ]))])
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass({ selectTag: _unref(selectTagNum) === '4' })
              }, [
                _createElementVNode("a", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (selectTag('4')))
                }, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("img", { src: "images/tabicon5.png" }, null, -1),
                  _createElementVNode("span", null, "信用体系", -1)
                ]))])
              ], 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("ul", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(newsList1), (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item.id,
                      onClick: ($event: any) => (showDetail(item))
                    }, [
                      _createElementVNode("small", _hoisted_10, _toDisplayString(item.releaseDate), 1),
                      _createElementVNode("a", null, [
                        _cache[10] || (_cache[10] = _createElementVNode("span", null, "•", -1)),
                        _createTextVNode(_toDisplayString(item.title), 1)
                      ])
                    ], 8, _hoisted_9))
                  }), 128))
                ])
              ])
            ], 512), [
              [_vShow, _unref(selectTagNum) === '0']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_11, null, 512), [
              [_vShow, _unref(selectTagNum) === '1']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("ul", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(newsList3), (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item.id,
                      onClick: ($event: any) => (showDetail(item))
                    }, [
                      _createElementVNode("small", _hoisted_16, _toDisplayString(item.releaseDate), 1),
                      _createElementVNode("a", null, [
                        _cache[11] || (_cache[11] = _createElementVNode("span", null, "•", -1)),
                        _createTextVNode(_toDisplayString(item.title), 1)
                      ])
                    ], 8, _hoisted_15))
                  }), 128))
                ]),
                (_unref(newsList3).length === 0)
                  ? (_openBlock(), _createBlock(_component_el_empty, {
                      key: 0,
                      "image-size": "100",
                      description: "暂无数据"
                    }))
                  : _createCommentVNode("", true)
              ])
            ], 512), [
              [_vShow, _unref(selectTagNum) === '2']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", { class: "InforDisclosure_con" }, [
                _createElementVNode("div", { class: "imgbtn_sub" }, [
                  _cache[13] || (_cache[13] = _createElementVNode("a", {
                    href: "http://www.singlewindow.ha.cn/",
                    target: "_blank",
                    onclick: "return confirm('是否跳转其他网址？')",
                    class: "t_gjmy"
                  }, [
                    _createElementVNode("span", { class: "img_icon" }),
                    _createElementVNode("span", { class: "img_text" }, "国际贸易单一窗口")
                  ], -1)),
                  _cache[14] || (_cache[14] = _createElementVNode("a", {
                    href: "http://bsdt.henanga.gov.cn/",
                    target: "_blank",
                    class: "t_sfrz"
                  }, [
                    _createElementVNode("span", { class: "img_icon" }),
                    _createElementVNode("span", { class: "img_text" }, "身份认证查询")
                  ], -1)),
                  _createElementVNode("a", {
                    class: "t_publicity",
                    onClick: publicity
                  }, [...(_cache[12] || (_cache[12] = [
                    _createElementVNode("span", { class: "img_icon" }, null, -1),
                    _createElementVNode("span", { class: "img_text" }, "审批（服务）公示", -1)
                  ]))])
                ])
              ])
            ], 512), [
              [_vShow, _unref(selectTagNum) === '3']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", { class: "InforDisclosure_con" }, [
                _createElementVNode("div", { class: "imgbtn_sub" }, [
                  _cache[18] || (_cache[18] = _createElementVNode("a", {
                    href: "http://xwqy.gsxt.gov.cn/",
                    target: "_blank",
                    class: "d_xwqy"
                  }, [
                    _createElementVNode("span", { class: "img_icon" }),
                    _createElementVNode("span", { class: "img_text" }, "小微企业名录")
                  ], -1)),
                  _createElementVNode("a", {
                    onClick: creditPublicity,
                    class: "d_cnzxm"
                  }, [...(_cache[15] || (_cache[15] = [
                    _createElementVNode("span", { class: "img_icon" }, null, -1),
                    _createElementVNode("span", { class: "img_text" }, "投资建设承诺制查询", -1)
                  ]))]),
                  _createElementVNode("a", {
                    onClick: VRList,
                    class: "d_cnzxm"
                  }, [...(_cache[16] || (_cache[16] = [
                    _createElementVNode("span", { class: "img_icon" }, null, -1),
                    _createElementVNode("span", { class: "img_text" }, "VR样板间", -1)
                  ]))]),
                  _createElementVNode("a", {
                    onClick: TZList,
                    class: "d_cnzxm"
                  }, [...(_cache[17] || (_cache[17] = [
                    _createElementVNode("span", { class: "img_icon" }, null, -1),
                    _createElementVNode("span", { class: "img_text" }, "投资决策参考", -1)
                  ]))])
                ])
              ])
            ], 512), [
              [_vShow, _unref(selectTagNum) === '4']
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})